






















































import { Component, Vue } from 'vue-property-decorator';
import { CurrentFamily, Family } from '@/types';
import { VButton, VHeader } from '@/components';
import Authentication from '@/utils/Authentication';
import { PathName } from '@/utils/enums';
import firebase from 'firebase';
import router from '@/router';

@Component({
  components: { VButton, VHeader }
})
export default class UserProfile extends Vue {
  family: Family | null = null;
  user: firebase.User | null = null;

  async mounted() {
    this.user = await Authentication.instance.getCurrentUser();
    this.family = await CurrentFamily.instance.getCurrentFamily();
  }

  async changePassword() {
    await router.safePush!(PathName.ChangePassword);
  }

  async logOut() {
    await Authentication.instance.signOut();
    await router.safePush!(PathName.SignIn);
  }

  async viewFamily() {
    await router.safePush!(PathName.Family);
  }

  async viewInvitations() {
    await router.safePush!(PathName.Invitations);
  }

  async viewPersonalInfo() {
    await router.safePush!(PathName.PersonalInformation);
  }
}
